import { render, staticRenderFns } from "./App.vue?vue&type=template&id=49baeb38&scoped=true"
var script = {}
import style0 from "./App.vue?vue&type=style&index=0&id=49baeb38&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49baeb38",
  null
  
)

export default component.exports